<template>
<div>
<Scholarship/>

</div>
</template>
<script>
import Scholarship from "../../components/Financial/Scholarship.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   Scholarship
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>